import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterHomePageHome = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("@honeycomb/home/home.css");
    import("@honeycomb/home")
      .then((lib) => {
        resolve({
          default: () => <lib.PageHome />,
        });
      })
      .catch(reject);
  });
});

export const LazyHomePageHome = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterHomePageHome />
    </Suspense>
  );
};
